import React, { useEffect, useState } from "react"
import styled from "styled-components"
import SplashImage from "../images/splash.png"
import { Close } from "styled-icons/material/Close"
import { shouldDisplaySplashInfo, setDidDisplaySplashInfo } from "../helpers/sessionUtil"
import withApolloClient from "../components/withApolloClient"
import { getSplashImageQueryGQL } from "../components/gql/homepage"
import { useQuery } from "@apollo/react-hooks"
import {
    FlexColumn, FullSlider
} from "@omnichannel/ace-b2b-elements/"

const ModalBackground = styled.div`
    display: visible; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1000; /* Sit on top */
    padding: ${props => ((props.isFullScreenOnMobile || props.isFullScreen) ? `0rem` : props.padding ? props.padding : "8.6rem 0rem")}; 
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: ${props => props.backgroundColor ? props.backgroundColor : 'rgba(0,0,0,0.4)'}; 
    @media only screen and (min-width: 700px) {
        padding: ${props => ((props.isFullScreen) ? `0rem` : "12rem 0rem")}; 
    }
    ${props => props.centerContent ? "display: flex; justify-content: center; align-items: center;" : ""}
    
`

const ModalContainer = styled.div`
    height: 100%;
    width: 40%;
    max-width: 400px; 
    justify-content: center;
    user-select: none;
    margin: auto;
    border-radius: .2rem;

    /* border: 1px solid #888; */
     width: ${props => ((props.isFullScreenOnMobile || props.isFullScreen) ? `80%` : "90%")};
    display: flex;
    flex-direction: column;
    ${props => props.style}

    // @media only screen and (min-width: 700px) {
    //     // width: ${props => ((props.isFullScreen) ? `100%` : "40%")};
    // }
    
    @media only screen and (min-width: 1024px) {
        max-width: 564px; //based on images dimension
    }
        

`

const SplashImageBox = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
`

const SplashImageObj = styled.img`
    // box-shadow: 0 .1rem .4rem  rgba(0,0,0, .2);
    display: block;
    width: 100%;
    height: auto;
`

const CloseButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: .3rem;
    position: relative;
    top: 1.7rem;
    left: 1.5rem;
    justify-content: flex-end;
    width: 100%;
    z-index: 9;
`

const CloseButtonWrapper = styled.div`
    background: rgba(255, 255, 255,  .9);
    width: fit-content;
    border-radius: 2rem;
    padding: .3rem;
`

const SplashModal = props => {
    var ref = React.createRef();
    const [displaySplashInfo, setDisplaySplashInfo] = useState(shouldDisplaySplashInfo())
    const splashModal = useQuery(getSplashImageQueryGQL)

    const hasImages = (!splashModal.loading &&
        splashModal.data &&
        splashModal.data.imageGroup &&
        splashModal.data.imageGroup.subImageGroup)
    const getImages = _ => {
        if (!splashModal.loading &&
            splashModal.data &&
            splashModal.data.imageGroup &&
            splashModal.data.imageGroup.subImageGroup) {
            return splashModal.data.imageGroup.subImageGroup
        }
        return []
    }

    // console.log(getImages())

    useEffect(() => {
        setDisplaySplashInfo(shouldDisplaySplashInfo());
    })


    return ((displaySplashInfo && hasImages) ?
        <ModalBackground
            ref={ref}
            isFullScreenOnMobile={true}
            onClick={(e) => {
                if (e.target === ref.current) {
                    {/* setDisplaySplashInfo(1);
                    setDidDisplaySplashInfo(1); */}
                }
            }}>
            <ModalContainer isFullScreenOnMobile={true}>
                <CloseButtonContainer>
                    <CloseButtonWrapper>
                        <Close
                            cursor={"pointer"}
                            size={"2rem"}
                            color={"#000"}
                            onClick={(e) => {
                                setDisplaySplashInfo(1);
                                setDidDisplaySplashInfo(1)
                            }}
                        />
                    </CloseButtonWrapper>
                </CloseButtonContainer>
                <FlexColumn>
                    <FullSlider
                        slides={1}
                        dots={false}
                        dotsBottomOffset={".6rem"}
                        dotsActiveColor={"white"}
                        dotsPassiveColor={"black"}
                        dotsWidth={"1.2rem"}
                        dotsFontSize={".8rem"}
                        autoplay
                        infinite
                    >
                        {getImages().map((data, index) => {
                            return <SplashImageObj src={data.base64} key={index} />
                        })}
                    </FullSlider>
                </FlexColumn>
            </ModalContainer>
        </ModalBackground> : null
    )
}

export default withApolloClient(SplashModal, { client: "smClient" })